import { httpGet, httpPost } from '../../../../../../utils/api.utils';
import { CIRCUIT_CATEGORIES as CircuitCategory } from '../../../../../../utils/constant.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../../utils/helpers.utils';
import { updatePlanTypes, getVendorDetails } from '../../../order-request.functions';

import { actions } from 'react-redux-form';

import {
    wirelineLocationModelB
    , wirelineSubscriptionModelB
    , wirelineBusinessModelB

    //ACTIONS
    , setCountryOptions
    , setPlanOptions
    , setVendorOptions
    , setVendorDetails
    , setPrimaryPlanDetails
    , setPurposeOfUseOptions
    , setFormSubmitted
} from './../../../../../../constants/model-reducers/external/request/wireline-request/new-circuit/new-circuit-exhibit-b.settings';

export const wirelineLocationModelBInitialState = wirelineLocationModelB;
export const wirelineSubscriptionModelBInitialState = wirelineSubscriptionModelB;
export const wirelineBusinessModelBInitialState = wirelineBusinessModelB;

const planDetailConst = {
    PlanId: 0
    , ComponentName: ''
    , ComponentCost: 0
    , ComponentDetails: ''
    , IsPrimary: true
}

const defaultState = () => ({
    countryOptions: []
    , addressOptions: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , planOptions: []
    , vendorDetails: {
        Currency: ''
    }
    , primaryPlanDetail: { ...planDetailConst }
    , purposeOfUseOptions: []
    , showOtherAddress: false
    , formSubmitted: false
});

const initialState = defaultState();

export const newCircuitExhibitBActions = {

    getNewCircuitFormData: () => async (dispatch, state) => {

        const { requestTypeId } = state().createRequest;

        var data = {
            RequestTypeId: requestTypeId
            , User: { ...getUserData() }
        };

        var res = await httpPost('external/orderRequest/getOrderForm', data);

        if (res != null) {
            dispatch({ type: setCountryOptions, data: res.Countries });
            dispatch({ type: setPurposeOfUseOptions, data: res.PurposeOfUse });
        }

    }
    , onCountrySelect: (model, value) => async (dispatch, state) => {

        const { countryOptions } = state().newCircuitExhibitBRequest;

        dispatch(actions.change(model, value));

        let country = countryOptions.find(o => o['Key'] === value).Value;
        dispatch(actions.change('wirelineLocationFormB.country', country));
        resetSubscriptionForm(dispatch);

    }
    , onVendorSelect: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelineSubscriptionFormB.planId', 0));
        dispatch(actions.change('wirelineSubscriptionFormB.planDetailsModel', wirelineSubscriptionModelB.planDetailsModel));
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });

        getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, value)
        updatePlanTypes(dispatch, setPlanOptions, value, CircuitCategory.fixed);

    }
    , onPlanSelect: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelineSubscriptionFormB.planDetailsModel', wirelineSubscriptionModelB.planDetailsModel));
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
        updatePlanDetails(dispatch, state, value);

    }
    , onQuantityChange: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));

        setTotalCost(dispatch, value, state().newCircuitExhibitBRequest.primaryPlanDetail.ComponentCost);
    }
    , onApproverSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineBusinessFormB } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineBusinessFormB.wireLineApprover', ''));
            dispatch(actions.change('wirelineBusinessFormB.wireLineApproverId', 0));
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.EmployeeId != wirelineBusinessFormB.wireLineApproverId) {
                dispatch(actions.change('wirelineBusinessFormB.wireLineApprover', obj.Name));
                dispatch(actions.change('wirelineBusinessFormB.wireLineApproverId', obj.EmployeeId));
            }
        }
    }

    , onSubscriptionFormLoad: () => async (dispatch, state) => {

        const { wirelineLocationFormB, wirelineSubscriptionFormB } = state().form;

        if (wirelineSubscriptionFormB.vendorDetailId !== '') return;

        var data = {
            ...wirelineLocationFormB
        };

        var res = await httpPost('external/orderRequest/getVendors', data);
        if (res.ok == undefined && res.PrefVendors.length > 0) {
            dispatch({
                type: setVendorOptions
                , prefVendors: res.PrefVendors
                , nonPrefVendors: res.NonPrefVendors
            });
            if (res.PrefVendors[0].Key != 0) {
                dispatch(actions.change('wirelineSubscriptionFormB.vendorDetailId', res.PrefVendors[0].Key));
                getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, res.PrefVendors[0].Key);
                updatePlanTypes(dispatch, setPlanOptions, res.PrefVendors[0].Key, CircuitCategory.fixed);
            }
        }

    }
    , resetNewCircuitForm: () => (dispatch, state) => {
        resetNewCircuitForm(dispatch);
    }
    , submitRequest: () => async (dispatch, state) => {

        const { requestTypeId, isWirelineRequest, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { wirelineLocationFormB, wirelineSubscriptionFormB, wirelineBusinessFormB } = state().form;

        //---->to be refactored 
        dispatch(actions.change('wirelineSubscriptionFormB.planDetails.planComponents', wirelineSubscriptionFormB.planDetailsModel));
        //---->end

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        var data = {
            // this block is temporary so that request will not fail (need refactor on the backend)
            LocationOrderModel: {
                ...wirelineLocationFormB
                , isWirelineRequest: isWirelineRequest
            }
            , SubscriptionModel: { ...wirelineSubscriptionFormB }
            , BusinessJustificationModel: { ...wirelineBusinessFormB }
            // end

            , WirelineLocationModel: { ...wirelineLocationFormB }
            , WirelineSubscriptionModel: { ...wirelineSubscriptionFormB }
            , WirelineBusinessModel: {
                ...wirelineBusinessFormB
            }
            , User: { ...userData }
            , NoEmail: false
            , RequestTypeId: requestTypeId
        };

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/orderRequest', data);

        if (!(res || res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }
}

function resetNewCircuitForm(dispatch) {

    dispatch(actions.reset('wirelineLocationFormB'));
    dispatch(actions.reset('wirelineSubscriptionFormB'));
    dispatch(actions.reset('wirelineBusinessFormB'));
    dispatch({ type: setCountryOptions, data: [] });
    dispatch({ type: setVendorDetails, data: { ...defaultState.vendorDetails } });
    dispatch({ type: setFormSubmitted, data: false });
}

function resetSubscriptionForm(dispatch) {
    dispatch(actions.reset('wirelineSubscriptionFormB'));
    dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
    dispatch({ type: setPlanOptions, data: [] });
    dispatch({ type: setVendorOptions, data: [] });
}

async function setTotalCost(dispatch, quantity, planCost) {

    dispatch(actions.change('wirelineSubscriptionFormB.totalCost', quantity * planCost));
}

async function updatePlanDetails(dispatch, state, id) {
    var res = await httpGet('external/orderRequest/getPlanComponentByPlan/' + id);

    if (res != null && res.length > 0) {

        dispatch(actions.change('wirelineSubscriptionFormB.planDetailsModel', res));

        var primaryPlan = res.filter(x => x.IsPrimary === true);

        if (primaryPlan != null && primaryPlan.length > 0) {
            dispatch({
                type: setPrimaryPlanDetails,
                data: primaryPlan[0]
            });

            setTotalCost(dispatch,state().form.wirelineSubscriptionFormB.quantity, primaryPlan[0].ComponentCost);
        }
    }
    return res != null;
}


export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setCountryOptions:
            return {
                ...state,
                countryOptions: action.data
            };
        case setVendorOptions:
            return {
                ...state,
                preferredVendorOptions: action.prefVendors
                , nonPrefVendorOptions: action.nonPrefVendors
            };
        case setPlanOptions:
            return {
                ...state,
                planOptions: action.data
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: action.data
            };
        case setPrimaryPlanDetails:
            return {
                ...state,
                primaryPlanDetail: action.data
            };
        case setPurposeOfUseOptions:
            return {
                ...state,
                purposeOfUseOptions: action.data
            };
        case setFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        default: return state;
    }
}